import React, { useState, useEffect } from 'react';
import { Container, Spinner, LoadingText, ProgressText, StatusText } from './styles';

const LoadingScreen = ({ progress }) => {
  const [displayProgress, setDisplayProgress] = useState(0);

  // Smooth progress updates
  // biome-ignore lint/correctness/useExhaustiveDependencies: <explanation>
  useEffect(() => {
    if (progress > displayProgress) {
      setDisplayProgress(progress);
    }
  }, [progress]);

  const formatProgress = (value) => {
    if (typeof value === 'number') {
      if (value > 1000000) {
        return `${Math.round(value / 1024 / 1024)}MB baixados`;
      }

      return `${Math.min(Math.round(value * 10) / 10, 100)}%`;
    }
    return '';
  };

  return (
    <Container>
      <Spinner />
      <LoadingText>Carregando arquivo DICOM...</LoadingText>
      {displayProgress > 0 && <ProgressText>{formatProgress(displayProgress)}</ProgressText>}
      <StatusText>
        {displayProgress === 0 ? 'Iniciando download...' : 'Download em andamento'}
      </StatusText>
    </Container>
  );
};

export default LoadingScreen;
